import { Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { VALUE_LINE_HEIGHT } from "web_myplann/Shared/Components/FlatRow/constants";
import { useFlatRowValueColor } from "web_myplann/Shared/Hooks/useFlatRowValueColor";

type Props = {
	value: string;
	placeholder?: string;
	icon?: LucideIcon;
	capitalize?: boolean;
	disabled?: boolean;
};

export const FlatRowTriggerValue: FC<Props> = ({
	value,
	placeholder,
	icon: Icon,
	capitalize,
	disabled,
}) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();
	const hasGoalsRight = useGoalsRightOptional();
	const valueColor = useFlatRowValueColor(disabled);

	const isEmpty = value === "";
	const emptyText =
		placeholder ?? (hasGoalsRight ? t(Resources.Common.Select) : undefined);

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			justifyContent="flex-end"
			gap={0.6}
			flex={1}
			minWidth={0}
		>
			<Typography
				variant={hasGoalsRight && isEmpty ? "body2" : "bodyMedium"}
				color={isEmpty ? palette.grey[300] : valueColor}
				minWidth={0}
				textAlign="right"
				textTransform={capitalize ? "capitalize" : undefined}
				lineHeight={`${VALUE_LINE_HEIGHT}px`}
				sx={{ overflowWrap: "anywhere" }}
			>
				{isEmpty ? emptyText : value}
			</Typography>
			{Icon && (
				<Stack
					direction="row"
					alignItems="center"
					flexShrink={0}
					height={`${VALUE_LINE_HEIGHT}px`}
				>
					<Icon size={iconSize.sm} color={palette.grey[400]} />
				</Stack>
			)}
		</Stack>
	);
};
